import actionConstants from './constants';
import { getCarIdSelector } from 'Selectors/reserve';
import { PLATFORM } from 'Constants/device.APP_TARGET';

export const RESERVE_REQUIRED_HEADER = { 'x-panamera-client-id': `web-${PLATFORM}` };

const getCarReserveStatus
    = adId =>
        (dispatch, getState, { get }) => {
            const state = getState();
            const carId = getCarIdSelector(state, adId);

            if (adId) {
                const URL = `/api/reserve/v1/cars/status?platform=pwa&itemId=${adId}${carId ? `&carId=${carId}` : ''}`;

                return dispatch(get(URL, actionConstants.CAR_RESERVE_STATUS, {}, RESERVE_REQUIRED_HEADER)).then(
                    response => {
                        if (response.ok) {
                            dispatch({
                                type: `CUSTOM_RECEIVE_${actionConstants.CAR_RESERVE_STATUS}`,
                                data: response?.data?.data ?? {},
                                adId,
                                carId
                            });
                        }
                        return response;
                    }
                );
            }
            return Promise.resolve(null);
        };

const resetReserveState = () => ({
    type: actionConstants.RESET_CAR_RESERVE_STATUS
});

export { getCarReserveStatus, resetReserveState };
